import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography
} from "@mui/material"
import Button from "components/Button"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { StyledGreyGrid } from "shared/styled/Global"

export const VehicleAlarmNotificationDelete = ({ deleteNotificationSubmit, result, id }) => {
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const { t } = useTranslation()

  const deleteNotification = () => {
    deleteNotificationSubmit(id)
  }

  useEffect(() => {
    if (result.status === 2) {
      setDialogOpen(false)
    }
  }, [result.status])

  const openRemoveDialog = () => {
    setDialogOpen(true)
  }

  const closeRemoveDialog = () => {
    setDialogOpen(false)
  }

  return (
    <>
      <Box marginTop={3} textAlign="center">
        <Grid container direction="column" justifyContent="center" alignItems="center" alignContent="center">
          <StyledGreyGrid item sx={{ padding: 3 }}>
            <Typography variant="h5">{t("global.remove_notification", "Remove notification")}</Typography>
            <Typography variant="bodySmall" color="textSecondary">
              {t(
                "vehiclealarm.the_user_will_no_longer_receive",
                "The user will no longer receive notifications about alarms for that company"
              )}
            </Typography>

            <Button color="primary" variant="text" onClick={openRemoveDialog}>
              {t("global.remove", "Remove")}
            </Button>
          </StyledGreyGrid>
        </Grid>
      </Box>

      <Dialog
        open={dialogOpen}
        onClose={closeRemoveDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          {t("global.remove_notification", "Remove notification")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t(
              "vehiclealarm.you_want_to_remove_the_notification",
              "Are you sure you want to remove the notification? The user will no longer receive notifications by email"
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeRemoveDialog} variant="text">
            {t("global.no_cancel", "No, cancel")}
          </Button>
          <Button
            result={result}
            onClick={() => deleteNotification(id)}
            variant="contained"
            color="primary"
            autoFocus>
            {t("global.yes_delete", "Yes, delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
